(ns common.schema.entities.sample-entity.permissions
  (:require [common.roles :as roles]))

(defn read-permissions?
  [_]
  true)

(defn disable-permissions?
  [{:keys [tr role entity has-write-permissions?]}]
  (when-not (or (roles/admin? role)
                (has-write-permissions? entity))
    (tr :not-allowed)))
